import { render } from "./patentList.vue?vue&type=template&id=f7eca464&scoped=true"
import script from "./patentList.vue?vue&type=script&lang=js"
export * from "./patentList.vue?vue&type=script&lang=js"

import "./patentList.vue?vue&type=style&index=0&id=f7eca464&scoped=true&lang=css"
import "./patentList.vue?vue&type=style&index=1&id=f7eca464&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7eca464"]])

export default __exports__